import { render, staticRenderFns } from "./PrkSyllabusBox.vue?vue&type=template&id=502cc99c&scoped=true&"
import script from "./PrkSyllabusBox.vue?vue&type=script&lang=js&"
export * from "./PrkSyllabusBox.vue?vue&type=script&lang=js&"
import style0 from "./PrkSyllabusBox.vue?vue&type=style&index=0&id=502cc99c&scoped=true&lang=scss&"
import style1 from "./PrkSyllabusBox.vue?vue&type=style&index=1&id=502cc99c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502cc99c",
  null
  
)

export default component.exports